import React, { Component } from 'react';
import { Button, Row, Col, Label, Modal, Input } from 'reactstrap';
import { NavLink, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import axios from 'axios';
import moment from 'moment';
import ErrorPopup from '../ErrorWindow/error-popup';
import MaskAmount from '../ExpendituresInfo/MaskAmount';
import ReimbursementStore from '../stores/ReimbursementStore';
import withNavigate from '../../Common/components/withNavigate';
import CustomProgressBar from '../CustomProgressBar/CustomProgressBar';


@observer
class ReviewSubmit extends Component {

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if (window.performance) {
            if (performance.navigation.type == 1) {
                const contextPath = window.location.pathname;
                window.location.href = contextPath;
            }
        }

        // keep the user on the same page on browser back button/arrow click
        window.onpopstate = () => {
            this.props.navigate(1);
        }
    }

    toggleModal = () => {
        const { navigate } = this.props;
        if (ReimbursementStore.errorCount > 0) {
            ReimbursementStore.setOpenModal();
        } else {
            ReimbursementStore.clearReimbursementForm();
            ReimbursementStore.setOpenModal();
            navigate('/');
        }
    }


    backNavigation = () => {
        const { navigate } = this.props;
        navigate('/documentation');
    }

    expenditures = (expenditureDetails, category) => {
        return (
            <>
                <Row className="label-font">
                    <Col className="pl-15" sm="6">
                        {`${category}: `} <b>{MaskAmount(ReimbursementStore.getSubTotalAmount(expenditureDetails, category))}</b>
                    </Col>
                </Row>
                {expenditureDetails.filter(x => x.expenditureCategory === category).map(exp => (
                    <Row className="mt-5 label-font" key={exp.expId}>
                        <Col sm="4">
                            <Label className="label-font" for={`reviewExpAmount${exp.expId}`}>
                                <b>Amount</b>
                            </Label>
                            <p name={`reviewExpAmount${exp.expId}`} className="label-font">
                                {MaskAmount(exp.expenditureAmount)}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for={`reviewExpDate${exp.expId}`}>
                                <b>Date</b>
                            </Label>
                            <p name={`reviewExpDate${exp.expId}`} className="label-font">
                                {moment(exp.expenditureDate).format("MM/DD/YYYY")}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for={`reviewExpDescription${exp.expId}`}>
                                <b>Description</b>
                            </Label>
                            <p name={`reviewExpDescription${exp.expId}`} className="label-font">
                                {exp.expenditureDescription}
                            </p>
                        </Col>
                        {
                            exp.expenditureDescOtherDetails &&
                            <Col sm="12">
                                <Label className="label-font" for={`reviewExpDescOtherDetails${exp.expId}`}>
                                    <b>Other</b>
                                </Label>
                                <p name={`reviewExpDescOtherDetails${exp.expId}`} className="label-font">
                                    {exp.expenditureDescOtherDetails}
                                </p>
                            </Col>
                        }
                        {
                            exp.expenditureETP &&
                            <Col sm="12">
                                <Label className="label-font" for={`reviewExpETPNarrative${exp.expId}`}>
                                    <b>ETP Narrative:</b>
                                </Label>
                                <p name={`reviewExpETPNarrative${exp.expId}`} className="label-font">
                                    {exp.expenditureETP}
                                </p>
                            </Col>
                        }
                        {category === 'Pantry Stocking' &&
                            exp.dietguidelines && exp.dietguidelines.length > 0 && (
                                <Col sm="12">
                                    <div className='attestItem mt-4'>
                                        <span>
                                            I, the provider, attest that the enrollee has received the resources on the Dietary Guidelines for Americans.
                                        </span>
                                    </div>
                                </Col>
                            )}
                        {category === "First Month's Rent" &&
                            exp.rentalAssistance && exp.rentalAssistance.length > 0 && (
                                <Col sm="12">
                                    <div className='attestItem mt-4'>
                                        <span>
                                            <b>Rental Assistance :</b>
                                        </span>
                                        <div className="mt-2">
                                            {ReimbursementStore.rentalAssistance}
                                        </div>
                                    </div>
                                </Col>
                            )}
                    </Row>
                ))
                }
                <hr />
            </>
        );
    }

    printPage = () => {

        const navlinkElements = document.getElementsByTagName('a');

        const buttonElements = document.getElementsByTagName('button');

        // hiding NavLinks & Buttons while printing
        [...navlinkElements].forEach(navlinkElement => {
            navlinkElement.classList.add('printing');
        });

        [...buttonElements].forEach(buttonElement => {
            buttonElement.classList.add('printing');
        })

        window.print();

        // un-hiding NavLinks & Buttons while printing
        [...navlinkElements].forEach(navlinkElement => {
            navlinkElement.classList.remove('printing');
        });

        [...buttonElements].forEach(buttonElement => {
            buttonElement.classList.remove('printing');
        })

    };

    @action handleSubmit() {
        ReimbursementStore.setReqFieldsValidationCheck();
        if (ReimbursementStore.reqFieldsValidationCheck) {
            ReimbursementStore.incrementErrorCount();
            ReimbursementStore.setOpenModal();
        } else {
            ReimbursementStore.turnOnBlocking();
            ReimbursementStore.responseErrors = [];
            const props = this.props;
            const postUrl = '/tapreimbursementrequestform/wa/api/v1/provconn/survey/tpa/submit';
            const data = ReimbursementStore.submitReimbursementForm();

            axios({
                method: 'post',
                url: postUrl,
                data: data
            })
                .then(function (response) {
                    ReimbursementStore.turnOffBlocking();
                    if (response && response.status === 200) {
                        if (response.data && response.data.confirmationNbr) {
                            ReimbursementStore.confirmationId = response.data.confirmationNbr;
                            ReimbursementStore.submitSuccess = true;
                            ReimbursementStore.responseErrors = [];
                            props.navigate('/confirmation');
                        } else {
                            ReimbursementStore.responseErrors = response.data && response.data.details ? response.data.details : [];
                            ReimbursementStore.incrementErrorCount();
                            ReimbursementStore.setOpenModal();
                        }
                    }
                    return response;
                })
                .catch(function (error) {
                    ReimbursementStore.incrementErrorCount();
                    ReimbursementStore.turnOffBlocking();
                    ReimbursementStore.responseErrors = [];
                    ReimbursementStore.setOpenModal();
                    return error;
                });
        }
    }


    render() {

        const {
            openModal,
            errorCount,
            providerInfo,
            enrolleeInfo,
            housingInfo,
            expenditureDetails,
            expGrandTotalAmount,
            expInfoNotes,
            reimbursementFormPages,
            attestRadio,
            providerAttestInfo,
            enrolleAttestInfo,
            documentUploadDetails
        } = ReimbursementStore;

        return (
            <>
                <CustomProgressBar pages={reimbursementFormPages} page="#reviewsubmit" />
                {/* Error Popup */}
                <Modal className="errorModal" isOpen={openModal} toggle={this.toggleModal}>
                    <ErrorPopup errorCount={errorCount} />
                </Modal>
                {/* Error Popup */}
                <div className="border-form">
                    <div className="spacer-30" />
                    <Row>
                        <Col sm="7">
                            <h2 className="poppinsH2">
                                Review and Submit
                            </h2>
                        </Col>
                    </Row>

                    <div className="spacer-30" />

                    <Row>
                        <Col sm="12">
                            <h2 className="poppinsH2">
                                <b>Provider & Enrollee</b>
                            </h2>
                            <div className="spacer-24" />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="10">
                            <h5 className="poppinsH5">
                                Provider Information
                            </h5>
                        </Col>
                        <Col sm="2">
                            <NavLink exact to="/reimbursementform" className="editBtn btn btn-link">
                                Edit
                            </NavLink>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <Label className="label-font" for="reviewProviderAgencyName">
                                <b>Provider Agency Name</b>
                            </Label>
                            <p name="reviewProviderAgencyName" className="label-font">
                                {ReimbursementStore.getProviderAgencyName(providerInfo)}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewProviderNPI">
                                <b>NPI</b>
                            </Label>
                            <p name="reviewProviderNPI" className="label-font">
                                {providerInfo.npi}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewProviderContactName">
                                <b>Contact Name</b>
                            </Label>
                            <p name="reviewProviderContactName" className="label-font">
                                {providerInfo.contactName}
                            </p>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <Label className="label-font" for="reviewProviderContactPhone">
                                <b>Provider Contact Phone</b>
                            </Label>
                            <p name="reviewProviderContactPhone" className="label-font">
                                {providerInfo.contactPhone}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewProviderContactEmail">
                                <b>Contact Email</b>
                            </Label>
                            <p name="reviewProviderContactEmail" className="label-font">
                                {providerInfo.contactEmail}
                            </p>
                        </Col>
                    </Row>

                    <hr className="mtb-35" />

                    <Row>
                        <Col sm="10">
                            <h5 className="poppinsH5">
                                Enrollee Information
                            </h5>
                        </Col>
                        <Col sm="2">
                            <NavLink exact to="/reimbursementform" className="editBtn btn btn-link">
                                Edit
                            </NavLink>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeFirstName">
                                <b>First Name</b>
                            </Label>
                            <p name="reviewEnrolleeFirstName" className="label-font">
                                {enrolleeInfo.firstName}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeMiddleInitial">
                                <b>Middle Initial</b>
                            </Label>
                            <p name="reviewEnrolleeMiddleInitial" className="label-font">
                                {enrolleeInfo.middleInitial}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeLastName">
                                <b>Last Name</b>
                            </Label>
                            <p name="reviewEnrolleeLastName" className="label-font">
                                {enrolleeInfo.lastName}
                            </p>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeDOB">
                                <b>DOB</b>
                            </Label>
                            <p name="reviewEnrolleeDOB" className="label-font">
                                {enrolleeInfo.dob !== '' ? moment(enrolleeInfo.dob).format('MM/DD/YYYY') : ''}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeAge">
                                <b>Age</b>
                            </Label>
                            <p name="reviewEnrolleeAge" className="label-font">
                                {enrolleeInfo.age}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeGender">
                                <b>Gender</b>
                            </Label>
                            <p name="reviewEnrolleeGender" className="label-font">
                                {enrolleeInfo.gender}
                            </p>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeProviderOneID">
                                <b>ProviderOne ID No.</b>
                            </Label>
                            <p name="reviewEnrolleeProviderOneID" className="label-font">
                                {enrolleeInfo.providerOneId}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeMedicaidEligibility">
                                <b>Medicaid Eligibility</b>
                            </Label>
                            <p name="reviewEnrolleeMedicaidEligibility" className="label-font">
                                {enrolleeInfo.medicaidEligibility}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeRecipientAid">
                                <b>Recipient Aid Category Code</b>
                            </Label>
                            <p name="reviewEnrolleeRecipientAid" className="label-font">
                                {enrolleeInfo.recipientAidCatCode}
                            </p>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeTribe">
                                <b>Is the enrollee a member of an American Indian/Alaskan Native Tribe?</b>
                            </Label>
                            <p name="reviewEnrolleeTribe" className="label-font">
                                {enrolleeInfo.tribe}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewEnrolleeTribeDetails">
                                <b>Name of recognized tribe</b>
                            </Label>
                            <p name="reviewEnrolleeTribeDetails" className="label-font">
                                {enrolleeInfo.tribeDetails}
                            </p>
                        </Col>
                    </Row>

                    <hr className="mtb-35" />

                    <Row>
                        <Col sm="10">
                            <h5 className="poppinsH5">
                                Housing Information
                            </h5>
                        </Col>
                        <Col sm="2">
                            <NavLink exact to="/reimbursementform" className="editBtn btn btn-link">
                                Edit
                            </NavLink>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <Label className="label-font" for="reviewHousingInfoStatus">
                                <b>Current Housing Status</b>
                            </Label>
                            <p name="reviewHousingInfoStatus" className="label-font">
                                {housingInfo.status}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewHousingInfoExitinganInstitution">
                                <b>Exiting an Institution</b>
                            </Label>
                            <p name="reviewHousingInfoExitinganInstitution" className="label-font">
                                {housingInfo.exitingInstitution}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewHousingInfoInstitutionType">
                                <b>Institution Type</b>
                            </Label>
                            <p name="reviewHousingInfoInstitutionType" className="label-font">
                                {housingInfo.typeOfInstitution}
                            </p>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <h6><strong>Supportive Housing (SH) Authoritzation Details</strong></h6>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <Label className="label-font" for="reviewHousingInfoSHAuthStartDate">
                                <b>SH Start Date</b>
                            </Label>
                            <p name="reviewHousingInfoSHAuthStartDate" className="label-font">
                                {housingInfo.authStartDate ? moment(housingInfo.authStartDate).format('MM/DD/YYYY') : ''}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewHousingInfoSHAuthEndDate">
                                <b>SH End Date</b>
                            </Label>
                            <p name="reviewHousingInfoSHAuthEndDate" className="label-font">
                                {housingInfo.authEndDate ? moment(housingInfo.authEndDate).format('MM/DD/YYYY') : ''}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewHousingInfoTreatmentNeed">
                                <b>Treatment Need</b>
                            </Label>
                            <p name="reviewHousingInfoTreatmentNeed" className="label-font">
                                {housingInfo.treatmentNeed}
                            </p>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <Label className="label-font" for="reviewHousingInfoCounty">
                                <b>Housing Size</b>
                            </Label>
                            <p name="reviewHousingInfoCounty" className="label-font">
                                {housingInfo.housingSize}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewHousingInfoCounty">
                                <b>County</b>
                            </Label>
                            <p name="reviewHousingInfoCounty" className="label-font">
                                {housingInfo.county}
                            </p>
                        </Col>
                        <Col sm="4">
                            <Label className="label-font" for="reviewHousingInfoRegion">
                                <b>Region</b>
                            </Label>
                            <p name="reviewHousingInfoRegion" className="label-font">
                                {housingInfo.region}
                            </p>
                        </Col>
                    </Row>

                    <hr className="mtb-35" />

                    <Row>
                        <Col sm="10">
                            <h5 className="poppinsH5">
                                Expenditure Information
                            </h5>
                        </Col>
                        <Col sm="2">
                            <NavLink exact to="/expendituresinfo" className="editBtn btn btn-link">
                                Edit
                            </NavLink>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    <Row>
                        <Col sm="4">
                            <h4 className="label-font">
                                <b>{`Expenditures: Grand Total = ${MaskAmount(expGrandTotalAmount)}`}</b>
                            </h4>
                        </Col>
                    </Row>

                    <div className="spacer" />

                    {expenditureDetails.filter(x => x.expenditureCategory === 'IDs and other documentation').length > 0 &&
                        this.expenditures(expenditureDetails, 'IDs and other documentation')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Application fees').length > 0 &&
                        this.expenditures(expenditureDetails, 'Application fees')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Transitional housing fees').length > 0 &&
                        this.expenditures(expenditureDetails, 'Transitional housing fees')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Relocation expenses').length > 0 &&
                        this.expenditures(expenditureDetails, 'Relocation expenses')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Move-in assistance').length > 0 &&
                        this.expenditures(expenditureDetails, 'Move-in assistance')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Exception to Policy (ETP)').length > 0 &&
                        this.expenditures(expenditureDetails, 'Exception to Policy (ETP)')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Security Deposits').length > 0 &&
                            this.expenditures(expenditureDetails, 'Security Deposits')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'First Month\'s Rent').length > 0 &&
                        this.expenditures(expenditureDetails, 'First Month\'s Rent')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Last Month\'s Rent').length > 0 &&
                        this.expenditures(expenditureDetails, 'Last Month\'s Rent')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Household Goods and Furniture').length > 0 &&
                        this.expenditures(expenditureDetails, 'Household Goods and Furniture')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Utility Set up Fees').length > 0 &&
                        this.expenditures(expenditureDetails, 'Utility Set up Fees')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Pantry Stocking').length > 0 &&
                        this.expenditures(expenditureDetails, 'Pantry Stocking')
                    }

                    {expenditureDetails.filter(x => x.expenditureCategory === 'Arrears: Rental').length > 0 &&
                        this.expenditures(expenditureDetails, 'Arrears: Rental')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Arrears: Storage').length > 0 &&
                        this.expenditures(expenditureDetails, 'Arrears: Storage')
                    }
                    {expenditureDetails.filter(x => x.expenditureCategory === 'Arrears: Utility').length > 0 &&
                        this.expenditures(expenditureDetails, 'Arrears: Utility')
                    }

                    <Row>
                        <Col sm="12">
                            <Label className="label-font" for="reviewExpInfoNotes">
                                <b>Notes</b>
                            </Label>
                            <p name="reviewExpInfoNotes" className="label-font">
                                {expInfoNotes}
                            </p>
                        </Col>
                    </Row>

                    <hr className="mtb-35" />

                    <Row>
                        <Col sm="10">
                            <h5 className="poppinsH5">
                                Moving Attestation
                            </h5>
                        </Col>
                        <Col sm="2">
                            <NavLink exact to="/movingattestation" className="editBtn btn btn-link">
                                Edit
                            </NavLink>
                        </Col>
                    </Row>
                    {attestRadio === 'Provider Attest' &&
                        <>
                            <Row className='mt-5'>
                                <Col sm="12">
                                    <div className='attestItem'>
                                        <div id="provAttest" className="circular-disabled" />
                                        <div>I, the provider, attest that the following enrollee is making a housing transition.</div>
                                    </div>
                                </Col>
                            </Row>

                            <div className="spacer" />
                            <div className="spacer" />

                            <Row className='ml-5'>
                                <Col sm="3">
                                    <Label className="label-font" for="reviewHousingInfoCounty">
                                        <b>First Name</b>
                                    </Label>
                                    <p name="reviewHousingInfoCounty" className="label-font">
                                        {providerAttestInfo.provAttFirstName}
                                    </p>
                                </Col>
                                <Col sm="3">
                                    <Label className="label-font" for="reviewHousingInfoCounty">
                                        <b>Last Name</b>
                                    </Label>
                                    <p name="reviewHousingInfoCounty" className="label-font">
                                        {providerAttestInfo.provAttLastName}
                                    </p>
                                </Col>
                                <Col sm="3">
                                    <Label className="label-font" for="reviewHousingInfoCounty">
                                        <b>Date Consent Received</b>
                                    </Label>
                                    <p name="reviewHousingInfoCounty" className="label-font">
                                        {providerAttestInfo.consentDate}
                                    </p>
                                </Col>
                            </Row>
                        </>
                    }

                    {attestRadio === 'Enrollee Attest' &&
                        <>
                            <Row className='mt-5'>
                                <Col sm="12">
                                    <div className='attestItem'>
                                        <div id="provAttest" className="circular-disabled" />
                                        <div>I, the enrollee, attest that I am making a housing transition.</div>
                                    </div>
                                </Col>
                            </Row>

                            <div className="spacer" />
                            <div className="spacer" />

                            <Row className='ml-5'>
                                <Col sm="3">
                                    <Label className="label-font" for="reviewHousingInfoCounty">
                                        <b>First Name</b>
                                    </Label>
                                    <p name="reviewHousingInfoCounty" className="label-font">
                                        {enrolleAttestInfo.enrolleFirstName}
                                    </p>
                                </Col>
                                <Col sm="3">
                                    <Label className="label-font" for="reviewHousingInfoCounty">
                                        <b>Last Name</b>
                                    </Label>
                                    <p name="reviewHousingInfoCounty" className="label-font">
                                        {enrolleAttestInfo.enrolleLastName}
                                    </p>
                                </Col>
                                <Col sm="3">
                                    <Label className="label-font" for="reviewHousingInfoCounty">
                                        <b>Date Consent Received</b>
                                    </Label>
                                    <p name="reviewHousingInfoCounty" className="label-font">
                                        {enrolleAttestInfo.consentDate}
                                    </p>
                                </Col>
                                <Col sm="3">
                                    <Label className="label-font" for="reviewHousingInfoCounty">
                                        <b>Time Consent Received</b>
                                    </Label>
                                    <p name="reviewHousingInfoCounty" className="label-font">
                                        {enrolleAttestInfo.consentTime}
                                    </p>
                                </Col>
                            </Row>
                        </>
                    }


                    <div className="spacer" />
                    <div className="spacer" />
                    <Row>
                        <Col sm="10">
                            <h5 className="poppinsH5">
                                Documents
                            </h5>
                        </Col>
                        <Col sm="2">
                            <NavLink exact to="/documentation" className="editBtn btn btn-link">
                                Edit
                            </NavLink>
                        </Col>
                    </Row>
                    {
                        documentUploadDetails.map(doc => (
                            doc.fileName ?
                                <div key={doc.documentName}>
                                    <Row className="mt-3 mb-5">
                                        <Col sm="6">
                                            <Label className="label-font label-font-sub">
                                                {
                                                    doc.documentName
                                                }
                                            </Label>
                                        </Col>
                                        <Col sm="6" >
                                            <Label className="label-font label-font-sub">
                                                {doc.fileName}
                                            </Label>
                                        </Col>
                                    </Row>

                                </div>
                                :
                                null
                        ))
                    }



                    <div className="pb-spacerRem-4" />

                    {/* <p className="review-printpdf-note" id="hide-ptag-while-print">
                        Please print your FCS TAP Reimbursement Request to paper or PDF and keep for your enrollee's records
                    </p> */}

                    <Button type="button" color={"primary"} className={'btn btn-primary backButton'} onClick={this.backNavigation}>
                        Back
                    </Button>

                    <div className="d-flex flex-row justify-content-end">

                        <Button type="button" color="link" className="btn btn-link printBtn" onClick={this.printPage}>
                            <i className="icon icon-print" />
                            Print Report
                        </Button>

                        <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"} onClick={this.handleSubmit}>
                            Submit
                        </Button>
                    </div>


                    <div className="pb-spacerRem-10" />
                </div>

            </>
        )
    }
}
export default withNavigate(ReviewSubmit);
ReviewSubmit.propTypes = {
    navigate: PropTypes.func
};
